import { type Block, type Ending, type Field, type FormDefinition, type Page, isField } from "@fobu/schema";

export interface BlockLocation {
  block: Block;
  page: Page;
  pageIndex: number;
  blockIndex: number;
}

/** Nachschlage-Index für ein Formular. Einmal pro Definition erzeugen und wiederverwenden. */
export interface FormIndex {
  def: FormDefinition;
  pageById: Map<string, { page: Page; index: number }>;
  blockById: Map<string, BlockLocation>;
  fieldById: Map<string, Field>;
  fieldByKey: Map<string, Field>;
  endingById: Map<string, Ending>;
  fields: Field[];
  defaultEnding: Ending;
}

const indexCache = new WeakMap<FormDefinition, FormIndex>();

export function indexForm(def: FormDefinition): FormIndex {
  const cached = indexCache.get(def);
  if (cached) return cached;
  const pageById = new Map<string, { page: Page; index: number }>();
  const blockById = new Map<string, BlockLocation>();
  const fieldById = new Map<string, Field>();
  const fieldByKey = new Map<string, Field>();
  const fields: Field[] = [];
  def.pages.forEach((page, pageIndex) => {
    pageById.set(page.id, { page, index: pageIndex });
    page.blocks.forEach((block, blockIndex) => {
      blockById.set(block.id, { block, page, pageIndex, blockIndex });
      if (isField(block)) {
        fieldById.set(block.id, block);
        fieldByKey.set(block.key, block);
        fields.push(block);
      }
    });
  });
  const endingById = new Map(def.endings.map((e) => [e.id, e] as const));
  const defaultEnding = (def.defaultEndingId && endingById.get(def.defaultEndingId)) || def.endings[0]!;
  const idx: FormIndex = { def, pageById, blockById, fieldById, fieldByKey, endingById, fields, defaultEnding };
  indexCache.set(def, idx);
  return idx;
}
